import { stateToComponentMap as ceStateMap } from '~/vue_merge_request_widget/stores/state_maps';

export const stateToComponentMap = {
  ...ceStateMap,
  geoSecondaryNode: 'mr-widget-geo-secondary-node',
};
